var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClothing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#D97706",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5982 17.7L16.3332 13L17.7995 11.9C17.8617 11.8535 17.9122 11.7931 17.947 11.7237C17.9818 11.6543 18 11.5777 18.0001 11.5C18.0001 10.837 17.7367 10.2011 17.2678 9.73223C16.799 9.26339 16.1631 9 15.5001 9C14.837 9 14.2012 9.26339 13.7323 9.73223C13.2635 10.2011 13.0001 10.837 13.0001 11.5C13.0001 11.6326 13.0528 11.7598 13.1465 11.8536C13.2403 11.9473 13.3675 12 13.5001 12C13.6327 12 13.7599 11.9473 13.8536 11.8536C13.9474 11.7598 14.0001 11.6326 14.0001 11.5C14.0011 11.1234 14.1437 10.7609 14.3997 10.4847C14.6556 10.2084 15.0061 10.0385 15.3816 10.0087C15.757 9.97896 16.1299 10.0915 16.4261 10.324C16.7224 10.5565 16.9204 10.892 16.9807 11.2638L15.2088 12.5931L15.1913 12.6062L8.40196 17.7C8.23418 17.8258 8.11021 18.0012 8.04758 18.2014C7.98495 18.4015 7.98684 18.6163 8.05297 18.8153C8.11911 19.0144 8.24614 19.1876 8.4161 19.3104C8.58607 19.4333 8.79036 19.4996 9.00008 19.5H22.0001C22.21 19.5 22.4145 19.434 22.5848 19.3112C22.7551 19.1885 22.8824 19.0153 22.9488 18.8162C23.0151 18.6171 23.0172 18.4022 22.9546 18.2018C22.892 18.0015 22.768 17.8259 22.6001 17.7H22.5982ZM22.0001 18.5H9.00008L15.5001 13.625L22.0001 18.5Z",
    fill: "#D97706"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothing);
export default __webpack_public_path__ + "static/media/Clothing.d98ee47a212318e0021ac18e9d11e2e8.svg";
export { ForwardRef as ReactComponent };